import { signal } from '@angular/core';
import { Confirmation } from 'primeng/api';

export interface ConfirmOptions extends Confirmation {
  severity?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'info'
    | 'warning'
    | 'danger';
}

export const confirmDialogSignal = signal<ConfirmOptions | undefined>(
  undefined,
);

export const confirmDialog = (options: ConfirmOptions) => {
  const severity = options.severity || 'primary';
  const icon = {
    primary: 'pi pi-info-circle',
    secondary: 'pi pi-info-circle',
    success: 'pi pi-check-circle',
    info: 'pi pi-info-circle',
    warning: 'pi pi-exclamation-triangle',
    danger: 'pi pi-exclamation-triangle',
  };
  confirmDialogSignal.set({
    icon: icon[severity],
    acceptLabel: 'OK',
    rejectLabel: 'Zrušiť',
    acceptButtonStyleClass: `p-button-${severity}`,
    rejectButtonStyleClass: 'p-button-secondary p-button-text',
    ...options,
  });
};
